import { NatureOfComplaint } from '@cod-monorepo/interfaces';

export const CodSubmittEndpoint: { [key: string]: string } = {
    [NatureOfComplaint.INTERNATIONAL_ORDER_ENTRY]: 'international/order-entry',
    [NatureOfComplaint.INTERNATIONAL_ITEM_OR_QUANTITY]: 'international/item-quantity',
    [NatureOfComplaint.INTERNATIONAL_PRODUCT_DATING]: 'international/product-dating',
    [NatureOfComplaint.INTERNATIONAL_PRODUCT_TEMPERATURE]: 'international/product-temperature',
    [NatureOfComplaint.INTERNATIONAL_DELIVERY]: 'international/delivery',
    [NatureOfComplaint.INTERNATIONAL_DOCUMENTATION]: 'international/documentation',
    [NatureOfComplaint.INTERNATIONAL_INVOICE_ERROR]: 'international/invoice-error',
    [NatureOfComplaint.INTERNATIONAL_QUALITY]: 'international/quality',
    [NatureOfComplaint.INTERNATIONAL_PRODUCT_DAMAGE]: 'international/product-damage',
    [NatureOfComplaint.DOMESTIC_PRODUCT_DATING]: 'domestic/product-dating',
    [NatureOfComplaint.DOMESTIC_PRODUCT_DAMAGE]: 'domestic/product-damage',
    [NatureOfComplaint.DOMESTIC_ORDER_ENTRY]: 'domestic/order-entry',
    [NatureOfComplaint.DOMESTIC_DELIVERY]: 'domestic/delivery',
    [NatureOfComplaint.DOMESTIC_ITEM_OR_QUANTITY]: 'domestic/item-quantity',
    [NatureOfComplaint.DOMESTIC_PRODUCT_TEMPERATURE]: 'domestic/product-temperature',
    [NatureOfComplaint.DOMESTIC_LARGE_INSTRUMENT_WAREHOUSE]: 'domestic/large-instrument-warehouse',
    [NatureOfComplaint.DOMESTIC_ESKER]: 'domestic/esker',
    [NatureOfComplaint.DOMESTIC_INVOICE_ERROR]: 'domestic/invoice-error',
    [NatureOfComplaint.DOMESTIC_BILLING_ADJUSTMENT]: 'domestic/billing-adjustment'
};
